/*
 * @Description:日程
 * @Author: 山淑兰
 * @Date: 2020-05-09 18:42:05
 * @LastEditTime: 2020-05-21 17:06:14
 * @LastEditors: 山淑兰
 */
import { Get, Pick } from "@/api/utils";
import { IGetAPIProgram, IGetAPIExpertProgram,IGetAPIProDateRoom,IGetAPIExpertProList } from "./index.dto";

const API_HOST = "";

export const GetAPIProgram = {
  Get_Program: API_HOST + "/api/Program/GetAPIProgram", //会议基本信息接口
  Get_APIExpertProgram: API_HOST + "/api/Program/GetAPIExpertProgram", //嘉宾日程信息接口
  Get_ProDateRoom: API_HOST + '/api/Program/GetAPIProDateRoom', //获取日期会场
  Get_ExpertProList: API_HOST + '/api/Program/GetAPIExpertProList', //嘉宾列表
};
export default {
  /**
   * @title 获取当前会议日程信息
   * @date 2019-12-27
   */
  GetAPIProgram(body: IGetAPIProgram) {
    const params = Pick(body, IGetAPIProgram);
    return Get({
      url: GetAPIProgram.Get_Program,
      params,
    });
  },
  /**
   * @title 嘉宾日程信息
   * @date 2020-5-21
   */
  GetAPIExpertProgram(body: IGetAPIExpertProgram) {
    const params = Pick(body, IGetAPIExpertProgram);
    return Get({
      url: GetAPIProgram.Get_APIExpertProgram,
      params,
    });
  },
  /**
   * @title 日期列表
   * @date 2023-10-1
   */
  GetAPIProDateRoom(body: IGetAPIProDateRoom) {
    const params = Pick(body, IGetAPIProDateRoom);
    return Get({
      url: GetAPIProgram.Get_ProDateRoom,
      params,
    });
  },
  /**
   * @title 嘉宾列表
   * @date 2023-10-1
   */
  GetAPIExpertProList(body: IGetAPIExpertProList) {
    const params = Pick(body, IGetAPIExpertProList);
    return Get({
      url: GetAPIProgram.Get_ExpertProList,
      params,
    });
  },
};
